module.exports = {
    help: {
        pages: 5,
        pageNameFormat: "res/help/page_%d.jpg",
        priceFontName: "price-font",
        click:"res/sounds/help/click",
        backgroundMusic: "res/sounds/help/help_music",
        pricetable: [
            {
                symbol:0, //10
                wins:[5,4,3],
                position:{x:145, y:592},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:1, //A
                wins:[5,4,3],
                position:{x:445, y:592},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:2, //flower
                wins:[5,4,3],
                position:{x:735, y:255},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:3, //geisha
                wins:[5,4,3],
                position:{x:145, y:387},
                offset:{width:0, height:29},
                align:'center'
            },
            // 4 - bonus symbol
            // 5 - wild
            {
                symbol:6, //scatter (samurai)
                wins:[5,4,3],
                position:{x:735, y:592},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:7, //apple
                wins:[5,4,3],
                position:{x:445, y:255},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:8, //J
                wins:[5,4,3],
                position:{x:735, y:471},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:9, //firework
                wins:[5,4,3,2],
                position:{x:145, y:255},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:10, //K
                wins:[5,4,3],
                position:{x:735, y:364},
                offset:{width:0, height:29},
                align:'center'
            },
            {
                symbol:11, //Q
                wins:[5,4,3],
                position:{x:145, y:489},
                offset:{width:0, height:29},
                align:'center'
            }
        ]
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 10
// module chunks = 0